import { PageLabelFunctions } from '../types';
import { withdrawDeclaration } from './withdrawDeclaration';

export const Withdraw: PageLabelFunctions = {
    withdrawDeclaration,
};
